import React, { useCallback } from 'react';
import { IconButton } from '@chakra-ui/react';
import { Icon } from '../Icon/component.js';
import { i18n } from '../../../i18n/index.js';
import { Layout } from '../Layout/component.js';
var ClearInputButton = function ClearInputButton(_ref) {
  var inputRef = _ref.inputRef,
    clearField = _ref.clearField;
  var resetField = useCallback(function () {
    if (clearField) {
      clearField();
    }
    if (!inputRef.current) {
      return;
    }
    inputRef.current.value = '';
    inputRef.current.focus();
  }, [inputRef, clearField]);
  return /*#__PURE__*/React.createElement(IconButton, {
    onClick: resetField,
    variant: "ghost",
    colorScheme: "gray",
    isRound: true,
    paddingX: 0,
    "aria-label": i18n.t('Clear field'),
    icon: /*#__PURE__*/React.createElement(Layout, {
      pointerEvents: "none"
    }, /*#__PURE__*/React.createElement(Icon, {
      prefix: "fas",
      iconName: "xmark-circle"
    }))
  });
};
ClearInputButton.displayName = "ClearInputButton";
export { ClearInputButton };